import React, { useState, useEffect } from 'react';
import { fetchPersonalInfo, PersonalInfo } from '../data/contentService';
import SocialLinks from '../components/SocialLinks';
import './Contact.css';

const Contact: React.FC = () => {
  const [personalInfo, setPersonalInfo] = useState<PersonalInfo | null>(null);

  useEffect(() => {
    const loadPersonalInfo = async () => {
      try {
        const info = await fetchPersonalInfo();
        setPersonalInfo(info);
      } catch (error) {
        console.error('Error loading personal info:', error);
      }
    };

    loadPersonalInfo();
  }, []);

  return (
    <div className="contact">
      <div className="container">
        <header className="page-header">
          <h1>Contact</h1>
          <p>Get in touch with me for collaborations, questions, or discussions</p>
        </header>

        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-section">
              <h3>Email</h3>
              <p>
                <a href={`mailto:${personalInfo?.email || 'tmaaiveld@gmail.com'}`} className="contact-link">
                  {personalInfo?.email || 'tmaaiveld@gmail.com'}
                </a>
              </p>
            </div>

            <div className="contact-section">
              <h3>Institution</h3>
              <p>
                <strong>{personalInfo?.affiliation || 'TNO (Netherlands Organisation for Applied Scientific Research)'}</strong><br />
                {personalInfo?.location || 'Amsterdam, Netherlands'}
              </p>
            </div>

            <div className="contact-section">
              <h3>Research Interests</h3>
              <ul className="research-interests">
                {personalInfo?.interests ? (
                  personalInfo.interests.map((interest, index) => (
                    <li key={index}>{interest}</li>
                  ))
                ) : (
                  <>
                    <li>Artificial Intelligence</li>
                    <li>Machine Learning</li>
                    <li>Autonomous Systems</li>
                    <li>Military Simulation</li>
                  </>
                )}
              </ul>
            </div>

            <div className="contact-section">
              <h3>Connect With Me</h3>
              {personalInfo?.social ? (
                <SocialLinks social={personalInfo.social} />
              ) : (
                <div className="professional-links">
                  <a 
                    href="https://github.com/tmaaiveld" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="professional-link"
                  >
                    GitHub
                  </a>
                  <a 
                    href="https://www.linkedin.com/in/tmaaiveld/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="professional-link"
                  >
                    LinkedIn
                  </a>
                  <a 
                    href="https://www.researchgate.net/profile/Thomas-Maaiveld" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="professional-link"
                  >
                    ResearchGate
                  </a>
                </div>
              )}
            </div>
          </div>

          <div className="contact-simple">
            <h3>Get in Touch</h3>
            
            <div className="contact-email">
              <a 
                href={`mailto:${personalInfo?.email || 'tmaaiveld@gmail.com'}`}
                className="email-link"
              >
                📧 {personalInfo?.email || 'tmaaiveld@gmail.com'}
              </a>
            </div>
            
            <p className="contact-note">
              Click the button above to send me a message directly.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
